<template>
  <DocumentView api-type="quotes" type="Devis" />
</template>

<script>
import DocumentView from '@/components/Templates/DocumentView'

export default {
  components: {
    DocumentView,
  },
}
</script>
